import { MDBBtn, MDBCheckbox, MDBInput, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CustomSelect } from "../../../CustomSelect";
import { DayPicker } from "react-day-picker";
import { ASParamEditorProps } from "../ASParamEditor";


export const ASHolidayParam = ({currentValue, realValue, onCurrentValueChange, disabled}: ASParamEditorProps<{day: number, month: number, year: number}[]>) => {

    const [selectedDate, setSelectedDate] = useState<null|number>(null);
    const selectedDateVal = useMemo<{day: number, month: number, year: number}>(() => (currentValue ?? [])[selectedDate ?? -1] ?? 0, [currentValue, selectedDate]);
    const selectedDateDT = useMemo<Date|null>(() => dateNumberToDate(selectedDateVal), [selectedDateVal]);

    const onDateSelect = useCallback((date: Date|undefined) => {
        if (!date || selectedDate == null || currentValue == null || currentValue[selectedDate] == undefined) return;
        const day = date.getDate(),
            month = date.getMonth()+1,
            year = date.getFullYear();
        
        onCurrentValueChange(currentValue.map((d, idx) => idx !== selectedDate ? d : ({day, month, year})));
    }, [selectedDate, currentValue, onCurrentValueChange]);

    const onDateClear = useCallback(() => {
        if (selectedDate == null || currentValue == null || currentValue[selectedDate] == undefined) return;

        onCurrentValueChange(currentValue.map((d, idx) => idx !== selectedDate ? d : ({day: 0, month: 0, year: 0})));
    }, [selectedDate, currentValue, onCurrentValueChange]);

    const onDateToggleRecurrent = useCallback(() => {
        if (selectedDate == null || currentValue == null || currentValue[selectedDate] == undefined) return;

        onCurrentValueChange(currentValue.map((d, idx) => idx !== selectedDate ? d : ({...d, year: 0})));
    }, [selectedDate, currentValue, onCurrentValueChange]);

    useEffect(() => {
        if (currentValue !== null && currentValue.length > 0 && selectedDate == null) setSelectedDate(0);
    }, [currentValue, selectedDate]);

    return (
        <div>
            <div className="d-flex flex-row align-items-center">
                <CustomSelect
                    items={(currentValue ?? []).map((val, idx) => ({
                        val: idx,
                        title: dateNumberToText(val)
                    }))}
                    defaultTitle="No data"
                    selected={selectedDate}
                    disabled={disabled}
                    onSelect={val => setSelectedDate(Number(val))}
                    width={350}
                />
                <MDBBtn
                    color="link"
                    className="ms-2 p-2"
                    onClick={onDateClear}
                >Clear</MDBBtn>
            </div>
            
            {selectedDate !== null && <>
                <div className="d-flex flex-column">
                    <DayPicker
                        key={selectedDate}
                        mode="single"
                        captionLayout="dropdown"
                        selected={selectedDateDT ?? undefined}
                        defaultMonth={selectedDateDT ?? undefined}
                        fromYear={new Date().getFullYear()-5}
                        toYear={new Date().getFullYear()+5}
                        onSelect={onDateSelect}
                        disabled={disabled}
                        style={{margin: 0, marginTop: '5px'}}
                    />
                    
                </div>
                <div className="d-flex flex-row justify-content-start align-items-center">
                    <MDBCheckbox
                        type="checkbox"
                        checked={selectedDateVal.year == 0}
                        onChange={onDateToggleRecurrent}
                        label="Every year"
                        labelStyle={{lineHeight: 1.4}}
                        disabled={disabled}
                    />
                </div>
                
            </>}
        </div>
    )
}

const dateNumberToText = (val: {day: number, month: number, year: number}) => {
    if (val.day==0 || val.month == 0) return 'N/A';
    return `${val.day < 10 ? '0':''}${val.day}.${val.month < 10 ? '0':''}${val.month}${val.year > 0 ? `.${val.year}`:''}`;
}

const dateNumberToDate = (val: {day: number, month: number, year: number}) => {
    if (val.day == 0 || val.month == 0) return null;
    else return new Date(val.year, val.month-1, val.day);
}